import { Factory } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  capacityReached: false,
  fullName: faker.person.fullName(),
  email: faker.internet.email(),
  expectedArrivalTime: faker.date.future(),
  locationId: 1,

  afterCreate(selfCertify, server) {
    const userData = server.createList('graphql/user-data', 3);
    selfCertify.update({ userData });
  },
});
